export default {
    "app.save-changes": "Save Changes",
    "app.required-fields": "* required field",
    "app.month": "month",
    "users.login.dont-have-account": "Don't have an account?",
    "users.login.sign-up": "Sign Up",
    "users.login.forgot-password": "Forgot your password?",
    "users.login.log-in": "Login",
    "users.login.enable-user": "Enable account and login",
    "users.login.bad-password": "Incorrect password",
    "users.login.bad-email": "This email doesn't have an account",
    "users.login.error-disabled": "This account is currently disabled",
    "users.login.already-have-account": "Already have an account?",
    "users.login.google": "Login with",
    "users.login.or": "OR",
    "users.signup.invalid-email": "Invalid email",
    "users.signup.invalid-password": "Password must be at least 6 characters long",
    "users.signup.email-used": "This email is already in use",
    "users.signup.password-unmatched": "The passwords don't match",
    "users.input.user": "Username",
    "users.input.email": "Email address",
    "users.input.password": "Password",
    "users.input.confirm-password": "Confirm password",
    "users.password-format": "The password has to be at least 6 characters long",
    "users.log-out": "Log out",
    "users.recover-password.title": "Reset your password",
    "users.recover-password.send": "Send email",
    "users.recover-password.sent-toast": "An email was sent to {email}. Follow the instructions to reset your password.",
    "users.recover-password.error.email": "You have to type a valid email",
    "users.recover-password.error.no-account": "This email isn't linked to any account",
    "app.error.not-found": "Ups, something went wrong",
    "app.error.not-found-message": "This page was not found. Try going back to Home page",
    "app.error.not-logged-in": "This page was not found. Try logging in.",
    "app.error.go-home": "Go Home",
    "app.home": "Home",
    "app.search": "Search",
    "app.group": "Groups",
    "app.menu": "Menu",
    "app.my-drive": "My Drive",
    "app.squad-flix": "SquadFlix",
    "app.my-profile": "Profile",
    "app.verify-account": "Send Verification Email",
    "app.verify-account.send-success": "Verification email sent successfully",
    "app.verify-account-message": "Some features are disabled until verification",
    "app.verify-account-again": "Verification email sent.",
    "app.verify-account-again.countdown": "Send it again in ",
    "input-save-edit.invalid-feedback": "This field is required",
    "selector-save-edit.invalid-feedback": "You have to select an option",
    "profile.image.not-verified": "You cant change your profile pick until you verify your email",
    "profile.crop-modal.title": "Crop new image",
    "profile.crop-modal.complete": "Complete crop",
    "profile.change-password": "Change password",
    "profile.change-password.save": "Save new password",
    "profile.user-info": "User Info",
    "profile.app-config": "Application Options",
    "profile.app-config.dark-mode": "Dark mode",
    "profile.app-config.receive-emails": "Receive Emails",
    "profile.current-password": "Current Password",
    "profile.new-password": "New Password",
    "profile.confirm-new-password": "Confirm New Password",
    "profile.update-password": "Change Password",
    "profile.update-password.text": "Enter your current password and a new password",
    "profile.update-password.unchanged-password": "The new password must differ from your current password",
    "profile.user-suppress": "Account Deletion",
    "profile.user-suppress.text": "You can recover your account in any moment after being disabled",
    "profile.user-suppress.disable": "Disable account",
    "profile.user-suppress.delete": "Delete account",
    "profile.user-delete.warning.title": "Delete Account",
    "profile.user-delete.warning.message": "Are you sure you want to delete your account? All your files and information will be deleted. Confirm your password and continue if you want to do this.",
    "profile.user-delete.warning.message-google": "Are you sure you want to delete your account? All your files and information will be deleted. Press continue and login with your google account to confirm.",
    "profile.user-delete.warning.button": "Continue",
    "profile.user-delete.confirm.message": "Your account will be completely deleted. This action is not reversible!",
    "profile.user-delete.confirm.button": "DELETE!",
    "profile.user-delete.incorrect-password": "Incorrect password, couldn't continue deleting your account.",
    "profile.user-delete.incorrect-account": "Incorrect google account, couldn't continue deleting your account.",
    "profile.user-delete.error-deleting": "There was an unexpected error deleting your account, try again later.",
    "profile.user-delete.successfully-deleted": "Your account was successfully deleted",
    "profile.auth-method": "Authentication method",
    "profile.auth-method.google-text": "Authenticated with",
    "profile.auth-method.password-text": "Authenticated with Email + Password",
    "profile.change-username.error": "Your can only change your username once every 30 days",
    "profile.change-username.success": "Your username has been updated successfully",
    "profile.change-photo.success": "Your profile photo has been updated successfully",
    "profile.change-password.success": "Your password has been updated successfully",
    "profile.user-code": "User id",
    "profile.manage-subscription": "Manage Subscription",
    "modal.cancel": "Cancel",
    "modal.confirm": "Confirm",
    "modal.close": "Close",
    "drive.contextual.add-file": "Select files",
    "drive.contextual.files.empty": "Select files to upload, or drop them here directly.",
    "drive.contextual.files.empty-phone": "Select files to upload, the upload queue will appear here.",
    "drive.contextual.queue.exceeds-size": "1 or more files can't be uploaded. Max file size is {fileSize}",
    "drive.contextual.queue.already-uploading": "Couldn't add to queue: This file is already being uploaded",
    "drive.no-files": "This is empty, try uploading new files.",
    "drive.create-folder": "New folder",
    "drive.create-folder-short": "Folder",
    "drive.new-folder.name": "Folder Name",
    "drive.create-folder.error-name": "The folder's name must be at least 3 characters long.",
    "drive.create-folder.success": "New folder created successfully",
    "drive.files-selected-info": "files",
    "drive.folders-selected-info": "folders",
    "drive.move-selected": "Move",
    "drive.delete-selected": "Delete",
    "drive.recycle-bin": "Recycle Bin",
    "drive.recycle-bin-short": "Bin",
    "drive.file-row.delete-button": "Delete from bin",
    "drive.file-row.recover-button": "Restore item",
    "drive.no-recycle-bin.no-files": "Your recycle bin is empty",
    "drive.recycle-bin.confirm-delete.title": "Delete bin item",
    "drive.recycle-bin.confirm-delete-all.title": "Delete all items",
    "drive.recycle-bin.confirm-delete.message": "Are you sure you want to continue? This action cannot be undone. The next file will be permanently deleted:",
    "drive.recycle-bin.confirm-delete-all.message": "Are you sure you want to continue? This action cannot be undone. The bin will be emptied and all files and folders will be deleted.",
    "drive.contextMenu.delete-item": "Delete item",
    "drive.contextMenu.change-name": "Rename",
    "drive.contextMenu.open-item": "Open",
    "drive.delete-selected.confirm-trash": "Confirm delete folders",
    "drive.delete-selected.confirm-trash.message": "You have selected one or more folders. These folders will be deleted and all its items will be moved to the recycle bin.",
    "drive.recycle-bin.deleted-trash": "All your files in the recycle bin have been deleted successfully.",
    "drive.recycle-bin.clean-bin": "Delete all items",
    "drive.change-name.file-success": "The name of the file has been updated.",
    "drive.change-name.folder-success": "The name of the folder has been updated.",
    "drive.removed-items.moved-trash": "One or more items have been moved to the recycle bin.",
    "drive.moved-items.success": "One or more items have been moved to",
    "fileUploadMenu.drop-items.folder-forbidden": "Folders cannot be uploaded. You ought to select only files.",
    "file-viewer.uploaded-on": "Uploaded on",
    "file-viewer.share-file": "Share",
    "file-viewer.publish-file": "Publish",
    "file-viewer.publish-file.form-title": "Publish file in Groups",
    "file-viewer.publish-file.form.title": "Title",
    "file-viewer.publish-file.form.description": "Description",
    "file-viewer.publish-file.form.select-groups": "Select Groups",
    "file-viewer.publish-file.form.selected-groups": "Select Groups: ",
    "file-viewer.publish-file.form.description-placeholder": "Write some brief description of what you are sharing",
    "file-viewer.publish-file.form.no-valid-groups": "You don't have the rights to publish\ files in any group.",
    "file-viewer.publish-file.upload-info.wait": "Please, wait while your file \"{fileName}\" is being shared with your groups.",
    "file-viewer.publish-file.finished-title": "File Published ",
    "file-viewer.publish-file.finished-info": "Your file \"{fileName}\" has been shared with the following groups: ",
    "file-viewer.publish-file.reload-form": "Open publish form",
    "file-viewer.download-file": "Download",
    "file-viewer.file-not-supported": "File not supported by the file viewer",
    "file-viewer.mkv-warning": "Some explorers may have problems reproducing MKV files",
    "file-viewer.share-link-copied": "The share link was copied to your clipboard!",
    "profile.drive-status": "My drive status",
    "drive.user-size.total-size-info": "{usedSize} of {totalSize} used",
    "drive.user-size.need-space?": "Need more space?",
    "drive.user-size.max-size": "Max file size is {maxFileSize}",
    "errors.no-size": "The file {fileName} ({size}) exceeds your total size.",
    "drive.select-all-files": "Select all files",
    "drive.select-all-folders": "Select all folders",
    "groups.create-group": "New group",
    "groups.create-group-small": "New",
    "groups.title": "Groups",
    "groups.group-form.group-name": "Group Name",
    "groups.group-form.privacy": "Privacy",
    "groups.group-form.select-privacy": "Select group privacy",
    "groups.group-form.categories": "Categories",
    "groups.group-form.confirm-create": "Create",
    "groups.privacy.public": "Public",
    "groups.privacy.private": "Private",
    "groups.privacy.hidden": "Hidden",
    "groups.group-leader": "Leader",
    "groups.member": "Member",
    "groups.members": "Members",
    "groups.no-my-groups": "The groups you are in will appear here.",
    "groups.join-group": "Join",
    "groups.join-group.error": "Error joining: this group might have been deleted.",
    "groups.reject-join-group": "Reject",
    "groups.ask-to-join": "Ask to join",
    "groups.invitation": "Invitation",
    "groups.already-asked": "You asked to join",
    "groups.join-more-groups": "Want to join more groups?",
    "groups.group-limit-reached": "You have reached the maximum number of groups you can join.",
    "group-search.title": "Search Groups",
    "group-search.input-searcher": "Group keywords",
    "group-search.input-searcher.text": "The search will be made by group's name and categories.",
    "search-results.title": "Search Results",
    "group-search.no-results": "No groups found for the given search keywords.",
    "group-search.showing-results": "Showing results for: ",
    "group-search.load-more": "Load more items",
    "group-details.search-files": "Search files in group",
    "group-details.group-menu": "Group Menu",
    "group-details.group-menu.join-petitions": "Join Petitions",
    "group-details.group-menu.invite-users": "Invite Users",
    "group-details.group-menu.danger-options": "Group Actions",
    "group-details.group-menu.group-info-edit": "Edit Group",
    "group-details.group-menu.no-join-petitions": "There are no petitions to join the group.",
    "group-details.group-menu.invited-info": "This user has been invited successfully: ",
    "group-details.group-menu.invited-info.not-found": "This user does not exist.",
    "group-details.group-menu.invited-info.already-joined": "This user has already joined the group.",
    "group-details.group-menu.invited-info.already-invited": "This user has already been invited.",
    "group-details.group-menu.leave-group": "Leave group",
    "group-details.group-menu.leave-group.success": "You have left the group successfully",
    "group-details.group-menu.delete-group": "Delete group",
    "group-details.group-menu.delete-group.error": "There was an unexpected error deleting the group",
    "group-details.group-menu.delete-group.success": "The group has been deleted successfully",
    "group-details.group-menu.leave-group.error": "You are the only user in the group. In order to leave this group, you have to delete it.",
    "group-details.group-menu.roles": "Roles",
    "group-details.group-menu.users": "Users",
    "group-details.group-menu.reload-roles": "Reset users roles",
    "group-details.group-menu.tags": "Tags",
    "group-details.group-private": "This group is private",
    "group-details.group-hidden": "This group is hidden",
    "group-details.group-private.details": "You have to join the group in order to see its files.",
    "group-details.not-found": "Group Not Found",
    "group-details.not-found.details": "This group doesn't exits. It might have been deleted.",
    "group-details.invite-info": "You have been invited to join this group",
    "group-details.group-private.info": "You can send a request to join the group.",
    "group-details.group-hidden.info": "You can only join hidden groups by invitation.",
    "group-invites.group": "group",
    "group-invites.groups": "groups",
    "group-invites.modal-title": "Group invitations",
    "group-post.posted-by": "Posted by",
    "group-post.description.show-more": "Show more",
    "group-post.description.show-less": "Show less",
    "group-post.post-delete.warning.title": "Delete post",
    "group-post.post-delete.warning.message": "Are you sure you want to delete this post?",
    "roles.create-role": "Create Role",
    "roles.role-form.field.name": "Role name",
    "roles.role-form.field.right-acceptUsers": "Accept Users",
    "roles.role-form.field.right-inviteUsers": "Invite Users",
    "roles.role-form.field.right-manageRoles": "Manage Roles",
    "roles.role-form.field.right-publishFiles": "Publish Files",
    "roles.role-form.field.right-modifyInfo": "Edit Group Info",
    "roles.role-form.field.right-kickUsers": "Kick Users",
    "roles.role-form.field.right-manageTags": "Manage Tags",
    "roles.role-form.field.right-administrator": "Administrator",
    "roles.role-form.field.right-administrator-info": "Admin will have all rights",
    "roles.role-form.field.right-tagOwnFiles": "Tag Own Posts",
    "roles.role-form.field.right-deletePosts": "Delete Posts",
    "roles.role-form.field.basic-rights": "Basics",
    "roles.role-form.field.user-rights": "Users",
    "roles.role-form.field.group-rights": "Group Management",
    "roles.role-form.field.admin-rights": "Admin Rights",
    "users-menu.more-users.info": "more users",
    "users-menu.kick-user.confirmation": "Kick %DISPLAY_NAME%?",
    "tags.create-tag": "Create tag",
    "tags.tag-form.field.name": "Tag",
    "shared-file.title": "Shared file",
    "subscriptions.unlock-info": "Unlock the full potential of SquadDisk with\ the <b>premium</b> subscription!",
    "subscriptions.unlocked-info": "You have all of these upgrades:",
    "subscriptions.upgrade.storage-title": "Boosted storage space",
    "subscriptions.upgrade.storage-info": "Get a generous 100GB of storage.",
    "subscriptions.upgrade.groups-title": "Unlimited group membership",
    "subscriptions.upgrade.groups-info": "Join as many groups as you like.",
    "subscriptions.upgrade.username-title": "Flexible username changes",
    "subscriptions.upgrade.username-info": "Modify your username whenever you want.",
    "subscriptions.upgrade.badge-title": "Premium Badge",
    "subscriptions.upgrade.badge-info": "Showcase your premium status with an exclusive badge.",
    "subscriptions.go-premium": "Go premium!",
    "subscriptions.manage-subscription.danger-access": "You will lose all the premium upgrades on: ",
    "subscription.automatic-payment.active-info": "Your subscription will be renewed automatically.",
    "subscription.next-payment-date": "Next payment date",
    "subscription.next-payment-cuantity": "Next payment quantity",
    "subscription.automatic-payment.activate": "Activate automatic payment",
    "subscription.automatic-payment.cancel": "Cancel automatic payment",
    "subscription.automatic-payment.cancel.confirm": "Are you sure you want to cancel your automatic payment? You will lose all your premium upgrades on {nextPayDate}",
    "subscription.subscription-end-date": "Subscription end date",
    "subscription.automatic-payment.suspended-info": "Your subscription wont be renewed automatically.",
    "app.no-posts.title": "Your feed is empty",
    "app.no-posts.description": "Try joining some groups to see their posts here.",
    "tmdb-notepad.modal-title": "My notepad",
    "tmdb-notepad.modal-title-description": "Start writing your notes!",
    "tmdb-notepad.modal-title-last-modified": "Modified: {date}",
    "tmdb-notepad.modal-warning": "Your notes are private and won't be shared with anyone.",
    "tmdb-result-card.info-icons.single-check": "You have starting watching this series",
    "tmdb-result-card.info-icons.double-check": "You have watched this",
    "tmdb-result-card.info-icons.cannot-play": "Not available to play",
    "tmdb-result-card.info-icons.can-play": "Available to play",
    "tmdb-result-card.info-icons.downloading": "Download in progress",
    "tmdb-result-card.info-icons.has-notes": "You have notes for this",
    "drive.file-row.error-dragging": "Can't move a folder inside itself",
    "tmdb-play-button.play": "Play",
    "tmdb-item-details.movie.back": "Back to movies",
    "tmdb-item-details.serie.back": "Back to series",
    "tmdb-item-details.back.from-notes": "Back to my notes",
    "tmdb-item-details.view-date": "Viewed on {date}",
    "tmdb-item-details.aired-date": "Aired on {date}",
    "tmdb-item-details.release-date": "Released on {date}",
    "tmdb-view-later.button.title": "Add to view later",
    "tmdb-view-later.button.remove-title": "Remove from view later",
    "squadflix-home.continue-watching": "Continue watching",
    "squadflix-home.new-episodes": "New episodes",
    "squadflix-home.new-episodes.see-now": "See now!",
    "squadflix-home.view-later": "View later",
    "squadflix-home.towers-stream": "Towers Stream",
    "squadflix.serie.season": "Season",
    "squadflix.serie.seasons": "Seasons",
    "squadflix.serie.episode": "Episode",
    "squadflix.serie.episodes": "Episodes",
    "squadflix.serie": "Serie",
    "squadflix.series": "Series",
    "squadflix.movie": "Movie",
    "squadflix.movies": "Movies",
    "squadflix-header.my-notes": "My notes",
    "squadflix-header.home": "Home",
    "squadflix-overview-card.show-overview": "Show overview",
    "squadflix-home.downloaded-torrents": "Downloaded Torrents",
    "torrents-dashboard.name": "Name",
    "torrents-dashboard.stats": "Stats",
    "torrents-dashboard.sort.date.desc": "Download date (desc)",
    "torrents-dashboard.sort.date.asc": "Download date (asc)",
    "torrents-dashboard.sort.size.desc": "Size (desc)",
    "torrents-dashboard.sort.size.asc": "Size (asc)",
    "torrents-dashboard.search": "Search torrents",
    "torrents-dashboard.confirm-delete": "¿Are you sure you want to delete this torrent?",
    "torrents-dashboard.file-deleted": "Torrent file deleted successfully",
    "squadflix.live": "Live",
    "tmdb-item-details.back.from-towersstream/dash": "Back to panel",
    "tmdb-item-details.back.from-squadflix": "Back to Squadflix",
    "tmdb-item-details.back.from-squadflixhome": "Back to Squadflix",
    "tmdb-item-details.back.from-my-profileprivate": "Back to my profile",
    "tmdb-item-details.back.from-home": "Back to home",
    "tmdb-item-details.back.from-squadflix-logs": "Back to View Logs",
    "tmdb-item-details.back.from-squadflixtowersstreamdash": "Back to TowersStream Dashboard",
    "tmdb-item-details.back.from-squadflixsearch-tmdb": "Back to search",
    "my-profile-collection-details.error.Forbidden": "You don't have permission to view this collection.",
    "userAppConfig.squadflix.header-type.0": "Trending Now",
    "userAppConfig.squadflix.header-type.1": "Trending Movies",
    "userAppConfig.squadflix.header-type.2": "Trending Series",
    "userAppConfig.squadflix.header-type.3": "Squadflix Originals",
    "userAppConfig.squadflix.showContinueWatchingSection": "Continue Watching",
    "userAppConfig.squadflix.showNewEpisodesSection": "New Episodes",
    "userAppConfig.squadflix.showViewLaterItems": "View Later",
    "userAppConfig.squadflix.showTrendingMoviesSection": "Trending Movies",
    "userAppConfig.squadflix.showTrendingSeriesSection": "Trending Series",
    "userAppConfig.squadflix.showLiveTvSection": "Live Channels",
    "userAppConfig.squadflix.showSquadflixOriginalsSection": "Squadflix Originals",
    "userAppConfig.squadflix.showTowersStreamSection": "Available TowersStream",
    "userAppConfig.squadflix.showLaLigaEventsSection": "Football Events",
}
